import { ActiveNotification, NotificationType } from './notifications.interface';

export const DefaultNotification: ActiveNotification = {
  duration: 3000,
  message: '',
  type: NotificationType.Success,
  showOnlyMessage: true,
};
